// src/Pages/PastEventsPage/PastEventsPage.js
import React from "react";
import "../LandingPage/LandingPage.css";
import "./PastEventsPage.css";
import logo from "../../assets/logo.webp";
import { assetUrl, useContent, useSettings } from "../../utils/useContent";
import SEO from "../../Components/SEO/SEO";

const FALLBACK_HEADER = {
  "halloffame.title": "ASX Hall of Fame",
  "halloffame.intro":
    "Wanna get your name engraved in our history books? Register your team now for a chance to win!",
};

export default function PastEventsPage() {
  const header = useSettings("halloffame.", FALLBACK_HEADER);
  const { items, loading } = useContent("hall-of-famers", []);

  return (
    <>
      <SEO
        title="Hall of Fame | All Star Xperience Montreal"
        description="Meet the ASX Hall of Famers — champions, MVPs and legends of the All Star Xperience Montreal 7v7 soccer leagues and tournaments."
        keywords="ASX Hall of Fame, Montreal soccer champions, 7v7 tournament winners Montreal"
      />
      <main className="lp-root pe-root">
        <div className="lp-content">
          <section className="section pe-hero">
            <div className="container">
              <div className="pe-hero-card card">
                <h1 className="h1" style={{ marginBottom: 10 }}>
                  {headerTitle(header["halloffame.title"])}
                </h1>
                <p className="p" style={{ marginBottom: 0 }}>
                  {header["halloffame.intro"]}
                </p>
              </div>

              {loading ? null : items.length === 0 ? (
                <div className="card pe-empty">
                  <div className="pe-empty-title">No hall of famers yet.</div>
                  <div className="pe-empty-sub">Check back after our next tournament!</div>
                </div>
              ) : (
                <ul className="pe-grid">
                  {items.map((ev) => (
                    <li key={ev.id ?? ev.title} className="card pe-card">
                      <div className="pe-imgWrap">
                        {ev.image_path ? (
                          <img
                            src={assetUrl(ev.image_path)}
                            alt={ev.title}
                            className="pe-img"
                            loading="lazy"
                          />
                        ) : (
                          <div className="pe-imgFallback">No image</div>
                        )}
                      </div>
                      <div className="pe-meta">
                        <div className="pe-title">{ev.title || "Untitled"}</div>
                        <div className="pe-winner">
                          <span className="pe-winnerLabel">Winner</span>
                          <span className="pe-winnerName">{ev.winner || "—"}</span>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
}

// Highlights "Hall of Fame" (or the last word group) in gold to match the
// original `<span class="accent">Hall of Fame</span>` treatment.
function headerTitle(title) {
  const t = String(title || "").trim();
  if (!t) return null;
  const hof = "Hall of Fame";
  const idx = t.toLowerCase().indexOf(hof.toLowerCase());
  if (idx === -1) return t;
  return (
    <>
      {t.slice(0, idx)}
      <span className="accent">{t.slice(idx, idx + hof.length)}</span>
      {t.slice(idx + hof.length)}
    </>
  );
}

/* Footer */
function Footer() {
  const year = new Date().getFullYear();
  const links = [
    { label: "Home", href: "/" },
    { label: "Leagues", href: "/leagues" },
    { label: "Hall of Fame", href: "/hall-of-fame" },
    { label: "Rules", href: "/rules" },
    { label: "About", href: "/about" },
    { label: "Register", href: "/register" },
  ];

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-top container">
        <div className="ft-col ft-brand">
          <div className="ft-logo">
            <img
              src={logo}
              alt="All Star Xperience"
              className="ft-logo-img"
              width="220"
              height="200"
            />
          </div>
        </div>

        <div className="ft-col explore-col">
          <h4 className="ft-title">Explore</h4>
          <ul className="ft-links">
            {links.map((l) => (
              <li key={l.label}>
                <a href={l.href}>{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className="ft-col" id="contact">
          <h4 className="ft-title">Contact</h4>
          <ul className="ft-contact">
            <li>
              <span className="ft-k">Email</span>
              <a href="mailto:allstarxperience@gmail.com">
                allstarxperience@gmail.com
              </a>
            </li>
            <li>
              <span className="ft-k">Phone</span>
              <a href="tel:+14387283726">+1 (438) 728-3726</a>
            </li>
            <li>
              <span className="ft-k">Phone</span>
              <a href="tel:+14385089880">+1 (438) 508-9880</a>
            </li>
            <li>
              <span className="ft-k">City</span>
              <span>Montreal, QC</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <span>
            © {year} All Star Xperience. All rights reserved. Developed by
            Riachiッ.
          </span>
        </div>
      </div>
    </footer>
  );
}
